export const isNotFalse = <T>(element: T | false | undefined | null): element is T => Boolean(element)
